import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import {
    CustomFieldDefinitionValue,
    CustomFieldValue,
    ParentChildOption,
    RichOption
} from '../../models/custom-field-value';
import { CustomFieldEntity } from '../../models/custom-field-entity';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldsService {
    constructor(
        private readonly httpClient: HttpClient,
        @Inject(APP_CONFIG) private readonly settings: Settings
    ) {}

    getValues(entity: CustomFieldEntity): Observable<CustomFieldValue[]> {
        const url = `${this.settings.coreAPIUrl}/AyaNova/customfields/values/${entity.entityType}/${entity.entityId}`;
        return this.httpClient.get<CustomFieldValue[]>(url).pipe(catchError(() => of([])));
    }

    getDefinitionWithValues(entity: CustomFieldEntity): Observable<CustomFieldDefinitionValue[]> {
        const url = `${this.settings.coreAPIUrl}/AyaNova/customfields/values/${entity.entityType}/${entity.entityId}`;
        return this.httpClient.get<CustomFieldDefinitionValue[]>(url).pipe(catchError(() => of([])));
    }

    /**
     * Used for searching rich dropdown options.
     */
    getRichOptions(definitionId: number, searchTerm: string): Observable<RichOption[]> {
        const encodedSearchTerm = encodeURIComponent(searchTerm);
        return this.httpClient.get<RichOption[]>(
            `${this.settings.coreAPIUrl}/AyaNova/customfields/definition/${definitionId}/rich-options?searchTerm=${encodedSearchTerm}`
        );
    }

    /**
     * Used for searching child dropdown options.
     */
    getChildOptions(definitionId: number, searchTerm: string, parentOption: string): Observable<ParentChildOption[]> {
        if (!parentOption?.length) {
            return of<ParentChildOption[]>([]);
        }

        const encodedSearchTerm = encodeURIComponent(searchTerm);
        const encodedParentOption = encodeURIComponent(parentOption);

        return this.httpClient.get<ParentChildOption[]>(
            `${this.settings.coreAPIUrl}/AyaNova/customfields/definition/${definitionId}/child-options?searchTerm=${encodedSearchTerm}&parentOption=${encodedParentOption}`
        );
    }
}
